<template>
  <div class="terms">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Terms of Service</h1>        
        </div>
      </div>
    </div>
    <div class="terms-of-service">
      <p>THE SOFTWARE IS PROVIDED &quot;AS IS&quot; WITHOUT ANY EXPRESS OR IMPLIED WARRANTY OF ANY KIND INCLUDING WARRANTIES OF MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE. IN NO EVENT SHALL Axes2 OR ITS SUPPLIERS BE LIABLE FOR ANY DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, BUSINESS INTERRUPTION, LOSS OF INFORMATION) ARISING OUT OF THE USE OF OR INABILITY TO USE THE SOFTWARE, EVEN IF Axes2 HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'terms',
    components : {
    },
    computed: {
    },
    data () {
        return {
        }
    },
    methods:{
    },
    mounted(){
    }
  }
</script>

<style lang="scss" scoped>
  .terms {
    font-family: Verdana;
  }
  .terms-of-service {
    color: white;
    margin-left: 10%;
    margin-right: 10%;
    padding: 20px;
    height: 1000px;
  }
  .hero {
    background-color: black;
  }
</style>